<mbs-input
  [appendButtons]="[
    {
      disabled: disabledState || disabledEye,
      icon: passwordInputType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash',
      id: 'changeTypePassword',
      tooltip,
      type: 'secondary'
    }
  ]"
  [autocomplete]="autocomplete || 'off'"
  [boldLabel]="boldLabel"
  [disabledSelf]="disabledSelf"
  [formControl]="control"
  [id]="id"
  [label]="label"
  [name]="name"
  [placeholder]="placeholder"
  [prependButtons]="prependButtons"
  [showRequiredMark]="showRequiredMark"
  [size]="size"
  [trim]="false"
  [type]="passwordInputType"
  [validationWhitespace]="validationWhitespace"
  (blur)="handleBlur($event)"
  (buttonClick)="changeTypePassword()"
  (focus)="handleFocus($event)">
  <ng-content
    ngProjectAs="[prependLabel]"
    select="[prependLabel]" />
  <ng-content
    ngProjectAs="[appendLabel]"
    select="[appendLabel]" />
</mbs-input>
